import React from 'react';

import tryItImg from '../../../../../public/images/index-page/try-it.svg';
import logoImg from '../../../../../public/images/logo-holdshort.svg';
import playMarketImg from '../../../../../public/images/google-play.webp';
import appleStoreImg from '../../../../../public/images/app-store.webp';
import videoDemoImg from '../../../../../public/images/index-page/video-demo.webp';
import demoCloudBgImg from '../../../../../public/images/index-page/cloud-bg.webp';
import demosMacbookImg from '../../../../../public/images/index-page/macbook.webp';
import demoImg from '../../../../../public/images/index-page/demo.png';
import demoPhoneImg from '../../../../../public/images/index-page/phone-white.png';
import appScreenImg from '../../../../../public/images/index-page/app-screens/app-screen2.png';
import cloudBgWebP from '../../../../../public/images/index-page/cloud-bg.webp';
import cloudBgPng from '../../../../../public/images/index-page/cloud-bg.png';
import planeContactWebP from '../../../../../public/images/index-page/airplate-contact.webp';
import planeContactPng from '../../../../../public/images/index-page/airplate-contact.png';
import phonePinkImg from '../../../../../public/images/index-page/phone-pink.png';
import phoneSilverImg from '../../../../../public/images/index-page/phone-silver.png';
import appScreen1Img from '../../../../../public/images/index-page/app-screens/app-screen1.png';
import bannerCompliance from '../../../../../public/images/index-page/banner_compliance.webp';
import bannerInvoicing from '../../../../../public/images/index-page/banner_invoicing.webp';
import bannerVersatility from '../../../../../public/images/index-page/banner_versatility.webp';


// About section images
import aboutImgSmall from '../../../../../public/images/index-page/about-img-small.png';
import aboutImgSmall2x from '../../../../../public/images/index-page/about-img-small@2x.png';
import aboutImgSmallWebP from '../../../../../public/images/index-page/about-img-small.webp';
import aboutImgSmall2xWebP from '../../../../../public/images/index-page/about-img-small@2x.webp';
import aboutImgBig from '../../../../../public/images/index-page/about-img-big.png';
import aboutImgBig2x from '../../../../../public/images/index-page/about-img-big@2x.png';
import aboutImgBigWebP from '../../../../../public/images/index-page/about-img-big.webp';
import aboutImgBig2xWebP from '../../../../../public/images/index-page/about-img-big@2x.webp';
import airplaneTopLeft from '../../../../../public/images/index-page/airplane-top-left.png';
import airplaneTopLeft2x from '../../../../../public/images/index-page/airplane-top-left@2x.png';
import airplaneTopLeftWebP from '../../../../../public/images/index-page/airplane-top-left.webp';
import airplaneTopLeft2xWebP from '../../../../../public/images/index-page/airplane-top-left@2x.webp';
import airplaneTopRight from '../../../../../public/images/index-page/airplane-top-right.png';
import airplaneTopRight2x from '../../../../../public/images/index-page/airplane-top-right@2x.png';
import airplaneTopRightWebP from '../../../../../public/images/index-page/airplane-top-right.webp';
import airplaneTopRight2xWebP from '../../../../../public/images/index-page/airplane-top-right@2x.webp';
import airplaneBottomLeft from '../../../../../public/images/index-page/airplane-bottom-left.png';
import airplaneBottomLeft2x from '../../../../../public/images/index-page/airplane-bottom-left@2x.png';
import airplaneBottomLeftWebP from '../../../../../public/images/index-page/airplane-bottom-left.webp';
import airplaneBottomLeft2xWebP from '../../../../../public/images/index-page/airplane-bottom-left@2x.webp';
import airplaneBottomRight from '../../../../../public/images/index-page/airplane-bottom-right.png';
import airplaneBottomRight2x from '../../../../../public/images/index-page/airplane-bottom-right@2x.png';
import airplaneBottomRightWebP from '../../../../../public/images/index-page/airplane-bottom-right.webp';
import airplaneBottomRight2xWebP from '../../../../../public/images/index-page/airplane-bottom-right@2x.webp';
// Icons
import icon1 from '../../../../../public/images/index-page/icons/1.svg';
import icon2 from '../../../../../public/images/index-page/icons/2.svg';
import icon3 from '../../../../../public/images/index-page/icons/3.svg';
import icon4 from '../../../../../public/images/index-page/icons/4.svg';
import icon5 from '../../../../../public/images/index-page/icons/5.svg';
import icon6 from '../../../../../public/images/index-page/icons/6.svg';
import icon7 from '../../../../../public/images/index-page/icons/7.svg';
import icon8 from '../../../../../public/images/index-page/icons/8.svg';
import icon9 from '../../../../../public/images/index-page/icons/9.svg';
import icon10 from '../../../../../public/images/index-page/icons/10.svg';
// App screens
import appScreen1WebP from '../../../../../public/images/index-page/app-screens/app-screen1.webp';
import appScreen12x from '../../../../../public/images/index-page/app-screens/app-screen1@2x.png';
import appScreen1WebP2x from '../../../../../public/images/index-page/app-screens/app-screen1@2x.webp';
import appScreen2 from '../../../../../public/images/index-page/app-screens/app-screen2.png';
import appScreen2WebP from '../../../../../public/images/index-page/app-screens/app-screen2.webp';
import appScreen22x from '../../../../../public/images/index-page/app-screens/app-screen2@2x.png';
import appScreen2WebP2x from '../../../../../public/images/index-page/app-screens/app-screen2@2x.webp';
import appScreen3 from '../../../../../public/images/index-page/app-screens/app-screen3.png';
import appScreen3WebP from '../../../../../public/images/index-page/app-screens/app-screen3.webp';
import appScreen32x from '../../../../../public/images/index-page/app-screens/app-screen3@2x.png';
import appScreen3WebP2x from '../../../../../public/images/index-page/app-screens/app-screen3@2x.webp';
import appScreen4 from '../../../../../public/images/index-page/app-screens/app-screen4.png';
import appScreen4WebP from '../../../../../public/images/index-page/app-screens/app-screen4.webp';
import appScreen42x from '../../../../../public/images/index-page/app-screens/app-screen4@2x.png';
import appScreen4WebP2x from '../../../../../public/images/index-page/app-screens/app-screen4@2x.webp';
import appScreen5 from '../../../../../public/images/index-page/app-screens/app-screen5.png';
import appScreen5WebP from '../../../../../public/images/index-page/app-screens/app-screen5.webp';
import appScreen52x from '../../../../../public/images/index-page/app-screens/app-screen5@2x.png';
import appScreen5WebP2x from '../../../../../public/images/index-page/app-screens/app-screen5@2x.webp';
// Web screens
import webScreensDay from '../../../../../public/images/index-page/web-scrins/web-screens-day.png';
import webScreensDayWebP from '../../../../../public/images/index-page/web-scrins/web-screens-day.webp';
import webScreensDay2x from '../../../../../public/images/index-page/web-scrins/web-screens-day@2x.png';
import webScreensDayWebP2x from '../../../../../public/images/index-page/web-scrins/web-screens-day@2x.webp';
import webScreensDaySmall from '../../../../../public/images/index-page/web-scrins/web-screens-day-small.png';
import webScreensDaySmallWebP from '../../../../../public/images/index-page/web-scrins/web-screens-day-small.webp';
import webScreensWeek from '../../../../../public/images/index-page/web-scrins/web-screens-week.png';
import webScreensWeekWebP from '../../../../../public/images/index-page/web-scrins/web-screens-week.webp';
import webScreensWeek2x from '../../../../../public/images/index-page/web-scrins/web-screens-week@2x.png';
import webScreensWeekWebP2x from '../../../../../public/images/index-page/web-scrins/web-screens-week@2x.webp';
import webScreensWeekSmall from '../../../../../public/images/index-page/web-scrins/web-screens-week-small.png';
import webScreensWeekSmallWebP from '../../../../../public/images/index-page/web-scrins/web-screens-week-small.webp';
import webScreensMonth from '../../../../../public/images/index-page/web-scrins/web-screens-month.png';
import webScreensMonthWebP from '../../../../../public/images/index-page/web-scrins/web-screens-month.webp';
import webScreensMonth2x from '../../../../../public/images/index-page/web-scrins/web-screens-month@2x.png';
import webScreensMonthWebP2x from '../../../../../public/images/index-page/web-scrins/web-screens-month@2x.webp';
import webScreensMonthSmall from '../../../../../public/images/index-page/web-scrins/web-screens-month-small.png';
import webScreensMonthSmallWebP from '../../../../../public/images/index-page/web-scrins/web-screens-month-small.webp';
// Download section images
import appStoreWebP from '../../../../../public/images/app-store.webp';
import appStore2x from '../../../../../public/images/app-store@2x.webp';
import appStoreWebP2x from '../../../../../public/images/app-store@2x.webp';
import googlePlayWebP from '../../../../../public/images/google-play.webp';
import googlePlay2x from '../../../../../public/images/google-play@2x.webp';
import googlePlayWebP2x from '../../../../../public/images/google-play@2x.webp';

const androidAppUrl = 'https://play.google.com/store/apps/details?id=com.holdshort&amp;hl=en_US';
const iosAppUrl = 'https://itunes.apple.com/us/app/holdshort/id1187603879?mt=8';

const howItWorksSec = {
  worksTitleH2: 'How it works',
  worksText: 'Add all your users, Pilots or Flight Instructors – no limits',
  worksTextSmall: 'Schedule it all: Simulators, dispatch staff, headsets – anything!',
  worksButton: 'Start your free 60 day trial'
};
const howItWorksVideo = {
  workVidAlt: 'Holdshort Watch demo presentation',
  workDemoVid: videoDemoImg,
  workIco: '/public/images/shapes.svg?v=3.1.481-t.689#play-triangle',
  demoVideoT: 'Watch demo presentation',
  demoVideoS: 'Holdshort App for Aircraft Scheduling'
};
const heroSection = {
  airplaneBg: '/public/images/index-page/airplane-bg.webp',
  tryItImg: tryItImg,
  logoImg: logoImg,
  logoAlt: 'Holdshort Logo',
  appleStoreLink: iosAppUrl,
  playMarketLink: androidAppUrl,
  phoneLinkTitle: 'Holdshort App',
  playMarketSrc: playMarketImg,
  playMarketTitle: 'Holdshort Google Play',
  appleStoreSrc: appleStoreImg,
  appStoreTitle: 'Holdshort App Store',
  tryItAlt: `Holdshort Try it! It's free!`,
  planeAlt: 'Holdshort airplane',
  signInHeading: 'Sign In Holdshort',
  authForm: '/authorization/login/',
  formSubmit: {
    signInText: 'Sign In',
    signUpText: 'Sign Up for free!',
    forgotPass: 'Forgot Password',
    forgotPassLink: '/authorization/recovery/'
  },
  heading: (
    <span>
      Use our apps to <b>schedule a plane</b> anytime, anywhere
    </span>
  ),
  headerText: 'For Flight Schools, Flying Clubs, FBOs, Aircraft Partnerships and General Aviation'
};
const indexDemo = {
  demoCloudBg: demoCloudBgImg,
  demosMacbookImg: demosMacbookImg,
  demoImg: demoImg,
  demoPhone: demoPhoneImg,
  appScreen: appScreenImg,
  demoPhoneTitle: 'Holdshort demo phone',
  phoneTitle: 'Holdshort demo phone white',
  macbookTitle: 'Holdshort demo macbook',
  macbookAlt: 'Holdshort macbook',
  cloudAlt: 'Holdshort white cloud',
  demoTitle: 'Demo',
  demoTextBig: 'To view a demo of our system, please first sign up for a free user account',
  demoTextSmall:
    'Request access to our live demo to see first-hand how our scheduling system can work for your aviation organization',
  buttText: 'Try demo!'
};
const contactSection = {
  infoContainer: {
    bgImgWebP: cloudBgWebP,
    bgImgPng: cloudBgPng,
    typePng: 'image/webp',
    alt: 'Holdshort white cloud',
    heading: 'Contact Us',
    text: 'If you have any questions, comments or suggestions, please feel free to contact us!',
    contactEmailLink: 'support@holdshort.com',
    indexContactFollow: 'Follow us:',
    linkTwitter: 'https://twitter.com/holdshortcom',
    hrefTwitter: '/public/images/shapes.svg?v=#twitter',
    linkFb: 'https://www.facebook.com/holdshort',
    hrefFb: '/public/images/shapes.svg?v=#facebook',
    linkYT: 'https://www.youtube.com/user/holdshortcom',
    hrefYT: '/public/images/shapes.svg?v=#youtube'
  },
  planeContact: {
    planeImgWebP: planeContactWebP,
    planeImgPng: planeContactPng,
    planeAlt: 'Holdshort contact'
  },
  contactAppLinks: {
    iosLink: iosAppUrl,
    iosHref: appleStoreImg,
    iosTitle: 'Holdshort App Store',
    androidLink: androidAppUrl,
    androidHref: playMarketImg,
    androidTitle: 'Holdshort Google Play'
  },
  contactAppFigure: {
    phonePinkImg: phonePinkImg,
    phoneAlt: 'Holdshort demo phone pink',
    appScreenImg: appScreenImg,
    appAlt: 'Holdshort contact app'
  },
  tplFooter: {
    footerContainer: (
      <span>
        © 2003 - 2022 Holdshort Aviation Systems, LLC.
        <br />
        All Rights Reserved. Version
      </span>
    ),
    footerNav: {
      navLinkDoc: '/documentation/',
      navTitleDoc: 'Documentation',
      navLinkContact: '/static/contact-us/',
      navTitleContact: 'Contact Us',
      navLinkTerms: '/static/terms-of-service/',
      navTitleTerms: 'Terms of Service',
      navLinkPrivacy: '/static/privacy-policy/',
      navTitlePrivacy: 'Privacy Policy'
    }
  }
};
const useAppsInfo = {
  iphoneImgPng: {
    img: phoneSilverImg,
    typePng: 'image/png',
    title: 'Holdshort phone silver',
    alt: 'iPhone with Holdshort app'
  },
  appScreen: {
    img: appScreen1Img,
    alt: 'Holdshort App Phone',
    typePng: 'image/png'
  },
  useAppContent: {
    textH2: (
      <span>
        Use our apps to <b>schedule</b> <b>a plane</b> anytime, anywhere
      </span>
    ),
    textP: 'For Flight Schools, Flying Clubs, FBOs, Aircraft Partnerships and General Aviation',
    appStoreImg: appleStoreImg,
    linkGplay: androidAppUrl,
    linkAppStore: iosAppUrl,
    appStoreTitle: 'Holdshort App Store',
    gPlayImg: playMarketImg,
    gPlayTitle: 'Holdshort Google Play'
  }
};
const iconsSection = [
  {
    ico: {
      href: '/public/images/shapes.svg?v=#man-with-tie',
      height: '20px',
      width: '26px'
    },
    title: 'Unlimited Instructors appearing on the schedule'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#hat',
      height: '30px',
      width: '21px'
    },
    title: 'Unlimited Pilots & Users'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#plane-include',
      height: '25px',
      width: '25px'
    },
    title: 'FAA Certificate Enforcement (Medical, Ratings, & Endorsements)'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#controls',
      height: '20px',
      width: '21px'
    },
    title: 'Unlimited Instructors appearing on the schedule'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#group',
      height: '31px',
      width: '31px'
    },
    title: 'Complete Maintenance Management'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#call-center-man',
      height: '24px',
      width: '25px'
    },
    title: 'Aircraft Dispatch Control'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#chat-bubbles-with-ellipsis',
      height: '26px',
      width: '20px'
    },
    title: 'Live Customer Support'
  },
  {
    ico: {
      href: '/public/images/shapes.svg?v=#strategy',
      height: '30px',
      width: '34px'
    },
    title: 'Initial Set-Up and Data Migration'
  }
];

const banner = [
  {
    name: 'Compliance',
    content: `Our aircraft scheduling software offers a wide range of 
        enforcement capabilities (Certificates, Ratings, FAA Flight Review,
        Medical, Organization Review, Renter’s Insurance, etc.) to ensure
        the eligibility of your pilots. In addition, the aircraft 
        hobbs and tach & meter tracking system will keep you notified 
        on maintenance inspections that come due.`,
    bannerImg: bannerCompliance
  },
  {
    name: 'Versatility',
    content: `The online scheduling software features a multi-tier role system that can be fully customized.
    This way, you can effortlessly distribute responsibilities between managers, instructors, pilots, students,
    etc.&nbsp; Apart from having default resources on the schedule such as aircraft and instructors, you may add
    custom resources such as staff and other equipment for complete scheduling management. Reservations for equipment
    can be made with a scheduled flight.`,
    bannerImg: bannerVersatility
  },
  {
    name: 'Invoicing',
    content: (
      <span>
        <p>
          Thanks to a secure external API with Stripe.com, the
          leading online credit card processing company for business,&nbsp;the Holdshort
          now&nbsp;includes an ability to issue and manage invoices for flights and specified
          products. As an addition to all aircraft scheduling and management features the scheduling
          application has to offer, our payment module makes holdshort the ultimate tool to handle
          your flight operations – all in one place!
        </p>
      </span>
    ),
    bannerImg: bannerInvoicing
  }
];
const aboutSection = {
  aboutCloudBg: demoCloudBgImg,
  altCloudBg: 'Holdshort white cloud',
  readMore: {
    btn: 'Read More >',
    link: '/news/'
  },
  aboutImgs: {
    imgSmallWebP:
      `${aboutImgSmallWebP}, ${aboutImgSmall2xWebP} 2x`,
    imgSmallPng:
      `${aboutImgSmall}, ${aboutImgSmall2x} 2x`,
    dataSrc: aboutImgSmall,
    title: 'Holdshort About Us small image'
  },
  imgBigFigure: {
    imgBigWebp:
      `${aboutImgBigWebP}, ${aboutImgBig2xWebP} 2x`,
    imgBigPng:
      `${aboutImgBig}, ${aboutImgBig2x} 2x`,
    dataSrc: aboutImgBig,
    imgBigTitle: 'Holdshort About Us big image'
  },
  airplaneTopLeft: {
    imgPlanWebp:
      `${airplaneTopLeftWebP}, ${airplaneTopLeft2xWebP} 2x`,
    imgPlanPng:
      `${airplaneTopLeft}, ${airplaneTopLeft2x} 2x`,
    dataSrc: airplaneTopLeft,
    titleTopLeft: 'Holdshort airplane top left'
  },
  svgSprite: {
    link: '/public/images/shapes.svg?v=#dotted-curve',
    height: '314px',
    width: '325px'
  },
  airplaneTopRight: {
    imgPlanWebp:
      `${airplaneTopRightWebP}, ${airplaneTopRight2xWebP} 2x`,
    imgPlanPng:
      `${airplaneTopRight}, ${airplaneTopRight2x} 2x`,
    dataSrc: airplaneTopRight,
    titleTopRight: 'Holdshort airplane top right'
  },
  airplaneBottomLeft: {
    imgPlanWebp:
      `${airplaneBottomLeftWebP}, ${airplaneBottomLeft2xWebP} 2x`,
    imgPlanPng:
      `${airplaneBottomLeft}, ${airplaneBottomLeft2x} 2x`,
    dataSrc: airplaneBottomLeft,
    titleBottomLeft: 'Holdshort airplane bottom left'
  },
  airplaneBottomRight: {
    imgPlanWebp:
      `${airplaneBottomRightWebP}, ${airplaneBottomRight2xWebP} 2x`,
    imgPlanPng:
      `${airplaneBottomRight}, ${airplaneBottomRight2x} 2x`,
    dataSrc: airplaneBottomRight,
    titleBottomRight: 'Holdshort airplane bottom right'
  },

  aboutT: (
    <span>
      <p>
        Our next generation online aircraft scheduling software provides a complete flight and pilot
        scheduling management solution to flying clubs, flight schools, FBOs, corporate flight
        departments, air carriers and charter operators. We are the premier online flight school
        software solution that has been developed with the specific needs of operators and business
        owners in mind. Our scheduling platform provides a complete online and app-based aircraft
        reservation solutions which provides the administrator complete control over their user's
        access and reservation authority.
      </p>
      <p>
        Organizations may now also seamlessly manage multiple locations from a single account. In
        addition, the scheduling system maintains complete pilot records for verification and
        compliance purposes prior to flight dispatch.
      </p>
    </span>
  )
};
const faq = [
  {
    name: 'Introduction',
    shortText:
      'Welcome to Holdshort.com, the most versatile, flexible, and powerful aviation management system. This next generation aircraft scheduling and management system provides a complete solution for single owners, aviation businesses, flight schools, FBOs, corporate aviation, air carriers and aircraft charter operations.'
  },
  {
    name: 'Creating a User Account',
    shortText:
      'A user account can be created by self-registering on the Holdshort.com site or by receiving an invitation from an organization.'
  },
  {
    name: 'Accepting an Invitation from an Organization',
    shortText:
      'An organization can invite you to join it. You will receive an email with the link to accept the invitation. If you don’t have an account, clicking on the link automatically creates an account for you. You are then redirected to the page to fill out mandatory personal information.'
  }
];
const infoIconsList = [
  {
    ico: icon1,
    alt: 'Add an unlimited number of pilots or users',
    title: 'Add an unlimited number of pilots or users',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon2,
    alt: 'Add an unlimited number of instructors at no charge!',
    title: 'Add an unlimited number of instructors at no charge!',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon3,
    alt: 'Add custom resource types',
    title: 'Add custom resource types',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon4,
    alt: 'Add multiple airport locations and different time zones',
    title: 'Add multiple airport locations and different time zones',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon5,
    alt: 'Control access to resources by pilot qualifications',
    title: 'Control access to resources by pilot qualifications',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon6,
    alt: 'Enforce FAA regulations',
    title: 'Enforce FAA regulations',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon7,
    alt: 'Find the nearest flight center',
    title: 'Find the nearest flight center',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon8,
    alt: 'Create an account with your pilot ratings and certificates',
    title: 'Create an account with your pilot ratings and certificates',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon9,
    alt: 'Easily join an existing flight organization',
    title: 'Easily join an existing flight organization',
    name: 'index-info-icon-round lazyload'
  },
  {
    ico: icon10,
    alt: 'Reserve aircraft online, 24/7 via any web browser or app',
    title: 'Reserve aircraft online, 24/7 via any web browser or app',
    name: 'index-info-icon-round lazyload'
  }
];
const appScreens = [
  {
    img1x: appScreen1Img,
    imgWebp1x: appScreen1WebP,
    img2x: appScreen12x,
    imgWebp2x: appScreen1WebP2x,
    alt: 'Holdshort App Screen'
  },
  {
    img1x: appScreen2,
    imgWebp1x: appScreen2WebP,
    img2x: appScreen22x,
    imgWebp2x: appScreen2WebP2x,
    alt: 'Holdshort App Events'
  },
  {
    img1x: appScreen3,
    imgWebp1x: appScreen3WebP,
    img2x: appScreen32x,
    imgWebp2x: appScreen3WebP2x,
    alt: 'Holdshort App Dashboard'
  },
  {
    img1x: appScreen4,
    imgWebp1x: appScreen4WebP,
    img2x: appScreen42x,
    imgWebp2x: appScreen4WebP2x,
    alt: 'Holdshort App View Event'
  },
  {
    img1x: appScreen5,
    imgWebp1x: appScreen5WebP,
    img2x: appScreen52x,
    imgWebp2x: appScreen5WebP2x,
    alt: 'Holdshort App Event'
  }
];
const webScreens = [
  {
    img1x: webScreensDay,
    imgWebp1x: webScreensDayWebP,
    img2x: webScreensDay2x,
    imgWebp2x: webScreensDayWebP2x,
    imgSmall1x: webScreensDaySmall,
    imgSmallWebp1x: webScreensDaySmallWebP,
    imgSmall2x: webScreensDaySmall,
    imgSmallWebp2x: webScreensDaySmallWebP,
    alt: 'Holdshort Dashboard Day'
  },
  {
    img1x: webScreensWeek,
    imgWebp1x: webScreensWeekWebP,
    img2x: webScreensWeek2x,
    imgWebp2x: webScreensWeekWebP2x,
    imgSmall1x: webScreensWeekSmall,
    imgSmallWebp1x: webScreensWeekSmallWebP,
    imgSmall2x: webScreensWeekSmall,
    imgSmallWebp2x: webScreensWeekSmallWebP,
    alt: 'Holdshort Dashboard Week'
  },
  {
    img1x: webScreensMonth,
    imgWebp1x: webScreensMonthWebP,
    img2x: webScreensMonth2x,
    imgWebp2x: webScreensMonthWebP2x,
    imgSmall1x: webScreensMonthSmall,
    imgSmallWebp1x: webScreensMonthSmallWebP,
    imgSmall2x: webScreensMonthSmall,
    imgSmallWebp2x: webScreensMonthSmallWebP,
    alt: 'Holdshort Dashboard Month'
  }
];
const downloadSection = {
  appLinks: {
    iosLink: iosAppUrl,
    playMarketLink: androidAppUrl
  },
  sourceImgWebp: {
    iosSrcSet: `${appStoreWebP}, ${appStoreWebP2x} 2x`,
    type: 'image/webp',
    gPlaySrcSet: `${googlePlayWebP}, ${googlePlayWebP2x} 2x`
  },
  sourceImgPng: {
    iosSrcSet: `${appleStoreImg}, ${appStore2x} 2x`,
    gPlaySrcSet: `${playMarketImg}, ${googlePlay2x} 2x`,
    type: 'image/png',
    iosImgSrc: appleStoreImg,
    gPlayImgSrc: playMarketImg,
    gPlayTitle: 'Holdshort Google Play',
    iosTitle: 'Holdshort App Store'
  }
};

export {
  howItWorksSec,
  howItWorksVideo,
  heroSection,
  indexDemo,
  contactSection,
  useAppsInfo,
  iconsSection,
  banner,
  aboutSection,
  faq,
  infoIconsList,
  appScreens,
  webScreens,
  downloadSection
};
